import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import style from './ReadMore.module.scss';
import useWindowResize from '../hook/UseWindowResize';

let defaultHeight = 85;

const ReadMore = (props) => {

  let {
    text,
    className,
    more = 'More',
    less = 'Less',
    line = 4
  } = props;

  let [showMore, setShowMore] = useState(false);
  let [collapseTextHeight, setCollapseTextHeight] = useState('76px');
  let [textHeight, setTextHeight] = useState('76px');
  const hiddenEl = useRef(null);

  const toggle = () => {
    setShowMore(!showMore);
  };

  const fullTextHeight = () => {
    return hiddenEl && hiddenEl.current?hiddenEl.current.clientHeight:defaultHeight;
  };

  const checkCollapseTextHeight = () => {
    if(text != null) {
      let lineHeight = parseFloat($('#readmore').css('line-height'));
      setCollapseTextHeight((lineHeight * line) + 'px');
    }
  }

  const resize = () => {
    let height = fullTextHeight();
    setTextHeight(height);
  };

  useWindowResize(resize);

  useEffect(() => {
    resize();
    checkCollapseTextHeight();
  }, [text]);

  return (
    <div className={`${className} ${style.ReadMore}`}>
      <div className={style.text} style={{height: showMore?textHeight:collapseTextHeight, transition: 'height 300ms'}}>
        <p id="readmore" className={style.desc}>{text}</p>
      </div>
      {fullTextHeight() >= defaultHeight &&
      <a onClick={toggle}>{showMore?less:more}</a>
      }
      <div ref={hiddenEl} className={style.hidden}>
        <p className={style.desc}>{text}</p>
      </div>
    </div>
  )

};

ReadMore.propTypes = {
  text: PropTypes.string,
  more: PropTypes.string,
  less: PropTypes.string,
  line: PropTypes.string
};

export default ReadMore;
